import styled from "styled-components";

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px 82px 0 80px;

  @media only screen and (max-width: 1050px) {
    padding: 12px 60px 0 60px;
  }

  @media only screen and (max-width: 768px) {
    padding: 12px 45px 0 30px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`;

export const TitleContent = styled.div`
  display: flex;
  margin-bottom: 64px;

  @media only screen and (max-width: 950px) {
    display: flex;
    flex-direction: column;
    margin-top: 36px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;

  @media only screen and (max-width: 950px) {
    margin-top: 16px;
    width: 100%;
  }
`;

export const TextLength = styled.span`
  align-self: end;
  margin-top: 4px;
  color: ${(props) => props.theme.colors.placeholder};
`;

export const InputLabelFileContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 64px;

  @media screen and (max-width: 980px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
